<div class="container">
  <div class="content">
    <ng-container *ngIf="qrcodeMode === GoogleCastQRCodeMode.CODE">
      <div class="instructions">
        <div class="instruction">
          <div class="instruction__left">
            <div class="instruction__step">1</div>
          </div>
          <div class="instruction__right">
            <div class="instruction__label">
              {{ 'PAGES.CAST_QRCODE.CONNECT_TO_WIFI' | translate }}
            </div>
            <div class="instruction__content">
              <img class="instruction__icon" src="assets/images/googlecast/wifi-blue.svg" alt="" />
              <span class="instruction__text">{{ gcState?.wifiSSID }}</span>
            </div>
          </div>
        </div>
        <div class="separator"></div>
        <div class="instruction">
          <div class="instruction__left">
            <div class="instruction__step">2</div>
          </div>
          <div class="instruction__right">
            <div class="instruction__label">
              {{ 'PAGES.CAST_QRCODE.SCAN_QRCODE' | translate: { registerUrl: gcState?.registerUrl ?? '' } }}
            </div>
            <div class="instruction__qrcode">
              <img class="instruction__qrcode__background" src="assets/images/googlecast/qrcode-bg.png" alt="" />
              <div #canvas class="instruction__qrcode__canvas"></div>
            </div>
            <span class="instruction__server">{{ gcState?.registerUrl }}</span>
          </div>
        </div>
        <div class="separator"></div>
        <div class="instruction">
          <div class="instruction__left">
            <div class="instruction__step">3</div>
          </div>
          <div class="instruction__right">
            <div class="instruction__label">
              {{ 'PAGES.CAST_QRCODE.ENTER_PIN' | translate }}
            </div>
            <div class="instruction__content">
              <span class="instruction__text">{{ gcState?.code }}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="qrcodeMode === GoogleCastQRCodeMode.WIFI">
      <div class="instructions">
        <div class="instruction">
          <div class="instruction__left">
            <div class="instruction__step">1</div>
          </div>
          <div class="instruction__right">
            <div class="instruction__label">
              {{ 'PAGES.CAST_QRCODE.CONNECT_TO_WIFI' | translate }}
            </div>
            <div class="instruction__content">
              <img class="instruction__icon" src="assets/images/googlecast/wifi-blue.svg" alt="" />
              <span class="instruction__text">{{ gcState?.wifiSSID }}</span>
            </div>
          </div>
        </div>
        <div class="separator"></div>
        <div class="instruction">
          <div class="instruction__left">
            <div class="instruction__step">2</div>
          </div>
          <div class="instruction__right">
            <div class="instruction__label">
              {{ 'PAGES.CAST_QRCODE.ENTER_PIN' | translate }}
            </div>
            <div class="instruction__content">
              <span class="instruction__text">{{ gcState?.wifiPassword }}</span>
            </div>
          </div>
        </div>
        <div class="or">
          <div class="or__separator"></div>
          <div class="or__text">{{ 'PAGES.CAST_QRCODE.OR' | translate }}</div>
          <div class="or__separator"></div>
        </div>
        <div class="instruction">
          <div class="instruction__left">
            <div class="instruction__step">1</div>
          </div>
          <div class="instruction__right">
            <div class="instruction__label">
              {{ 'PAGES.CAST_QRCODE.SCAN_QRCODE_WIFI' | translate }}
            </div>
            <div class="instruction__qrcode">
              <img class="instruction__qrcode__background" src="assets/images/googlecast/qrcode-bg.png" alt="" />
              <div #canvas class="instruction__qrcode__canvas"></div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="showSupportMessage">
      <div class="support-message">
        {{ supportMessage }}
      </div>
    </ng-container>
  </div>
</div>
